export default "__VITE_ASSET__BAwSpeXq__"